// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".icon--kzy_0 {\n  color: currentColor;\n}\n\n.box--jwERn {\n  stroke: currentColor;\n}\n\n.strap--VQgJC {\n  stroke: #00a555;\n}", "",{"version":3,"sources":["webpack://./src/gui/Components/Icons/Nav/Package/index.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".icon {\n  color: currentColor;\n}\n\n.box {\n  stroke: currentColor;\n}\n\n.strap {\n  stroke: #00a555;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": "icon--kzy_0",
	"box": "box--jwERn",
	"strap": "strap--VQgJC"
};
export default ___CSS_LOADER_EXPORT___;
